import { env } from "../env";
import type { OAuthConfig } from "./types";

export function createOAuthConfig(origin: string): OAuthConfig {
  const oauthBase = env.oauth.baseUrl.replace(/\/$/, "");
  const appBase = import.meta.env.BASE_URL;
  return {
    clientId: env.oauth.clientId,
    audience: env.oauth.audience,
    scope: env.oauth.scope,
    authUrl: `${oauthBase}/oauth2/auth`,
    tokenUrl: `${oauthBase}/oauth2/token`,
    userInfoUrl: `${oauthBase}/userinfo`,
    logoutUrl: `${oauthBase}/oauth2/sessions/logout`,
    redirectUri: `${origin}${appBase}callback`,
    postLogoutRedirectUri: `${origin}${appBase}logout-callback`,
  };
}
